import { createStyles, makeUiStyles, Theme } from '../../../../styles/styles';
import { fontText, hexToRgbA, StylesIndexInjections } from 'common-react';
import { AutocompleteMobileType } from '../../tools/Autocomplete.const';
import { fieldBoxShadow, focusStyle } from '../../../../styles/mixins';

export interface CustomAutocompleteStyleProps {
  isMobileIconDisplay?: boolean;
  mobileType?: AutocompleteMobileType,
}

export default makeUiStyles((theme: Theme) => createStyles({
  label: {
    textAlign: 'left',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
  },
  placeholder: {
    color: theme.variables.isDarkTheme ? theme.color.greys[20] : theme.color.greys[50],
  },
  arrowButton: {
    position: 'absolute',
    right: 8,
    color: theme.color.oranges[50],
    transition: 'transform 0.2s ease-in-out',
    willChange: 'transform',
  },
  arrowButtonOpen: {
    transform: 'rotate(180deg)',
  },
  searchIcon: {
    color: theme.color.greys[80]
  },
  button: {
    position: 'relative',
    height: 56,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 32px 16px 16px',
    border: `1px solid ${theme.color.greys[40]}`,
    backgroundColor: theme.color.greys[0],
    borderRadius: 8,
    font: fontText('normal', theme.fontSize.base, 20),
    color: theme.color.greys[80],
    overflow: 'hidden',
    '& > $fakeInputText': {
      paddingLeft: 8
    },
    '&:hover': {
      boxShadow: fieldBoxShadow(theme).bs1,
      outline: 'none',
      borderColor: theme.color.greys[80],
    },
    '&:focus-visible': {
      ...focusStyle(theme),
    }
  },
  buttonOpen: {
    boxShadow: fieldBoxShadow(theme).bs1,
    outline: 'none',
    borderColor: theme.color.greys[80],
  },
  buttonDisabled: {
    border: `1px solid ${hexToRgbA(theme.color.greys[40], 0.4)}`,
    outline: 'none',
    boxShadow: 'none',
    color: hexToRgbA(theme.color.greys[40], 0.4),
    pointerEvents: 'none',
  },
  fakeInputText: {},
}), { name: 'AutocompleteButton', index: StylesIndexInjections.UI_ATOMS });
